import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const EmptyHint = styled(Typography)`
  margin-top: 24px;
`

export default EmptyHint
